import { useEffect } from "preact/hooks";
import {
  getActiveBudgetScope,
  initializeWalletWatchDb,
  listBudgetCategoryOptions,
  listExpenseRows
} from "../lib/storage/walletWatchDb.js";
import { compactRows } from "./expensePageRows.js";

export function useExpensePageDataLoader({
  activeProfileId,
  activeYear,
  setCategoryOptions,
  setExpenseScope,
  setIsReady,
  setRows
}) {
  useEffect(() => {
    let isMounted = true;

    async function loadExpenseData() {
      await initializeWalletWatchDb();
      const scope = activeProfileId && activeYear
        ? { profileId: activeProfileId, year: activeYear }
        : await getActiveBudgetScope();
      const [storedRows, availableCategories] = await Promise.all([
        listExpenseRows(scope.profileId, scope.year),
        listBudgetCategoryOptions(scope.profileId, scope.year)
      ]);

      if (!isMounted) {
        return;
      }

      setExpenseScope(scope);
      setCategoryOptions(availableCategories);
      setRows(compactRows(storedRows));
      setIsReady(true);
    }

    loadExpenseData().catch((error) => {
      console.error("Failed to load expense data.", error);
      if (isMounted) {
        setIsReady(true);
      }
    });

    return () => {
      isMounted = false;
    };
  }, [activeProfileId, activeYear, setCategoryOptions, setExpenseScope, setIsReady, setRows]);
}
